import {
  thumbVariants,
  trackVariants,
} from '~/components/component-library/Toggle/styles'
import { type ToggleProps } from '~/components/component-library/Toggle/types'
import { cn } from '~/utils/tailwind-utils'

export { type ToggleProps } from '~/components/component-library/Toggle/types'

export const Toggle = ({
  isChecked,
  size = 'base',
  isDisabled = false,
}: ToggleProps) => (
  <div
    aria-hidden
    className={cn(trackVariants({ size, isDisabled, isChecked }))}
  >
    <div className={cn(thumbVariants({ size, isChecked }))} />
  </div>
)
